<template>
<div class="item" :class="itemClass">
  <div class="wrapper" v-tooltip="{
    content: skill || '',
    show: showTooltip,
    trigger: 'manual'
    }">
    <div class="dot" :class="dotClass"></div>
    <span class="skill-title" @mouseover="onHover" @mouseout="offHover" v-if="skill">{{ skill }}</span>
    <span v-else><a @click.prevent="addSkills">{{this.$t('profile.addSkills')}}</a> {{this.$t('profile.toYourProfile')}}</span>
  </div>
</div>
</template>

<script>
export default {
  props: {
    skill: {
      type: String,
      default: null
    }
  },
  computed: {
    dotClass () {
      if (this.skill) {
        return 'is-primary'
      } else {
        return 'is-light'
      }
    },
    itemClass () {
      if (this.skill) {
        return []
      } else {
        return ['is-extended']
      }
    }
  },
  methods: {
    addSkills () {
      if (!this.skill) {
        this.$emit('add')
      }
    },
    onHover (event) {
      const e = event.target
      if (e.offsetWidth < e.scrollWidth) {
        this.showTooltip = true
      }
    },
    offHover (ele) {
      this.showTooltip = false
    }
  },
  data: () => ({
    showTooltip: false
  })
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.item {
  display: block;
}

.wrapper {
  border: solid 1px $border-color;
  height: 2.125rem;
  width: 100%;
  border-radius: $border-radius;
  background-color: white;
  display: flex;
  align-items: center;
  padding-left: 0.75rem;
}

.dot {
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.dot.is-primary {
  background-color: $primary;
}

.dot.is-light {
  background-color: $background-color;
}

.is-clickable {
  cursor: pointer;
}

.skill-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/profile/skills/skill-item.vue